import { createSelector } from 'reselect';

import { IApplicationState } from '../../types/redux';
import { EType } from '../../repositories/journal/entities/page_info/PageInfoSchema';
import { selectMainArticlesMeta } from '../mainArticles';
import { selectArticleListMeta } from '../articleList';
import { IJournalMetaV2Schema } from '../../repositories/journal/entities/journal/JournalMetaV2Schema';
import { selectNewsList } from '../newsList';
import { selectBlogList } from '../blogList';

/**
 * Выбирает мету для разных листингов
 */
export const selectCurrentListingMeta = createSelector(
  (state: IApplicationState) => state,
  (_: IApplicationState, type: EType) => type,
  (state, type) => {
    switch (type) {
      case EType.MainPage:
        return selectMainArticlesMeta(state);

      case EType.Articles:
      case EType.Documents:
        return selectArticleListMeta(state);

      case EType.News:
        return selectNewsList(state).meta;

      case EType.Blogs:
        return selectBlogList(state).meta;

      default:
        return {} as IJournalMetaV2Schema;
    }
  },
);
